<template>
    <div class="SignWall" v-if="isshow">
        <!--背景图-->
        <div class="background">
            <!--<img :src="imgSrc" width="100%" height="100%" alt="" />-->
            <div class="wall_wrap">
                <!--名称-->
                <div class="activeName"><span>{{eventname}}</span><img :src="signqrcode" alt=""></div>
                <div class="wall_box" :style="{height:wallHeight}">
                    <el-carousel indicator-position="outside"  :interval="6000" :style="{height:wallHeight}" v-if="wallData.length>0">
                        <el-carousel-item  v-for="(item,index) in wallData" :key="index" :style="{height:wallHeight}">
                            <div class="wall_main">
                                <!--v-bind:style="classObj"-->
                                <div :class="[className,'wall_list']" v-for="(list,ind) in item" :key="ind" :style="classObj[ind]">
                                    <img :src="list.logourl?list.logourl:heade_bg" alt="">
                                    <p>{{list.nickname}}</p>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                    <div class="noSign" v-else>签到进行中</div>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
            <div class="signPoup">
                <div class="singleNum" v-if="wallList.length==1">
                    <img :src="wallList[0].logourl?wallList[0].logourl:heade_bg" alt="">
                    <p>{{wallList[0].nickname}}</p>
                    <p class="red">签到成功</p>
                </div>
                <div class="doubleNum"  v-if="wallList.length>1">
                    <div class="head">
                        <span v-for="(item,index) in wallList" :key="index">
                            <img :src="item.logourl?item.logourl:heade_bg" alt="" v-if="index<=4">
                        </span>
                    </div>
                    <p class="nameBox">
                        <span class="nameList">
                            <!--<b v-for="(item,index) in wallList" :key="index">{{item.nickname}}</b>-->
                            <b>{{name}}</b>
                        </span>
                        <span>等</span>
                    </p>
                    <p class="red">签到成功</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getsignwalldata} from 'api/signApi'
    import {mapActions} from 'vuex'
    import $ from 'jquery'
    export default {
        name: "SignWall",
        data(){
            return{
                className:"",
                dialogVisible:false,
                isshow:true, // 是否显示页面
                imgSrc:require('@/common/images/singInImg/wallbg.png'),
                heade_bg:require('@/common/images/singInImg/heade_bg.png'),
                eventname:'', // 活动名称
                signqrcode:'', // 二维码
                signtime:'', // 签到时间
                wallData:[],
                name:'',
                allListData:[], // 所有数据
                wallList:[],
                // classObj:{
                //     cssText:'',
                //     transition:'',
                //     transform:'',
                // },
                classObj:[],
                wallHeight:'', // 中间内容高度
                activeTime: new Date(), // 动画结束时间
                timer:'',
                timer2:'',
                num:24, // 一屏显示个数
                c:8.4, // 动画宽
                r:4.9, // 动画高
            }
        },
        mounted(){
            this.getHeight()
            this._getWall()
            this.timer = setInterval(() => {
                this._getWall()
            }, 10000);
            // window.setInterval(() => {
            //     setTimeout(() => {
            //         this._getWall()
            //     }, 0)
            // }, 10000)
            this.timer2 = setInterval(()=>{
                this.init()
            },3000)
          document.title="签到360-简单方便的签到工具-资鲸网"
        },
        methods:{
            _getWall(){
                this.setLoading(true);
                getsignwalldata({
                    data: {
                        signtime:this.signtime?this.signtime:''
                    },
                    success: data => {
                        this.setLoading(false);
                        this.isshow=true
                        this.wallList = data.data.list
                        if(!this.signtime){
                            this.eventname=data.data.eventname
                            this.signqrcode=data.data.signqrcode
                        }
                        if(this.wallList.length>0){
                            this.signtime=data.data.list[0].signtime
                            this.dialogVisible=true
                            setTimeout(() => {
                                this.dialogVisible=false
                            }, 3000)
                            this.name=''
                            this.wallList.forEach(item=>{
                                this.name+=item.nickname+'、'
                            })
                            this.name=this.name.substring(0,this.name.length-1)
                            this.allListData = [...data.data.list, ...this.allListData]
                            this.wallData = []
                            if(this.wallHeight<600+'px'){
                                this.num=12
                            }else if(this.wallHeight<700+'px'){
                                this.num=18
                            }
                            const count = Math.ceil(this.allListData.length/this.num)
                            for(let i=0;i<count;i++){
                                this.wallData.push(this.allListData.slice(this.num*i,this.num*(i+1)))
                            }
                        }
                    },
                    error: data => {
                        this.$message.error(data.msg)
                    },
                })
            },
            // 特效
            init(){
                this.classObj = [];
                this.className = ""
                let box = document.querySelector('.wall_box')
                if(this.wallHeight<600+'px'){
                    this.r=3
                }else if(this.wallHeight<700+'px'){
                    this.r=3.8
                }
                let w = box.offsetWidth/this.c,h = box.offsetHeight/this.r;
                for(let i=0;i<this.r;i++){
                    for(let j=0;j<this.c;j++) {
                        let _left = j * w,_top = i * h;
                        let obj = {
                            cssText:'width:'+w+'px;height:'+h+'px;left:'+_left+'px;top:'+_top+'px; opacity:0;background-position:'+(-_left) + 'px ' + (-_top) + 'px',
                            transition:'all '+ this.Random(1,1.8) +'s ease',
                            transform:'perspective(800px) translate3d('+this.Random(-200,200)+'px, '+this.Random(-200,200)+'px,300px) rotate('+this.Random(-90,90)+'deg) scale('+ this.Random(0,2) +')',
                        }
                        this.classObj.push(obj);
                    }
                }
                setTimeout(()=>{
                    this.className = "set"
                },1000);
            },
            Random(start,end){
                return Math.random()*(end-start)+start;
            },
            // 动态获取wall_box高度
            getHeight(){
                // this.wallHeight = $(window).height()-140+'px'
                this.wallHeight = $(window).height()-$('.wall_box').offset().top-20+'px'
                console.log(this.wallHeight)
            },
            // getwalllist(item){
            //     console.log(item)
            //     const num = 24
            //     const count = Math.ceil(item.length/num)
            //     for(let i=0;i<count;i++){
            //         this.wallData.push(item.slice(num*i,num*(i+1)))
            //     }
            //     console.log(this.wallData)
            // },
            ...mapActions([
                'setLoading',
            ])
        },
        beforeDestroy() {
            //清除定时器
            clearInterval(this.timer);
            clearInterval(this.timer2);
        },
        destroyed() {
            //清除定时器
            clearInterval(this.timer);
            clearInterval(this.timer2);
        }
    }
</script>

<style lang="scss">
.SignWall{
    overflow: hidden;
    .background{
        width:100%;
        height:100vh;
        z-index:-1;
        background: url("../../common/images/singInImg/wallbg.png") no-repeat;
        background-size: cover;
        .wall_wrap{
            width: 1000px;
            margin: 0 auto;
            /*<!--z-index:1;-->*/
            /*<!--position: absolute;-->*/
            /*<!--top: 50%;-->*/
            /*<!--left: 50%;-->*/
            /*<!--transform: translate(-50%,-50%);-->*/
            .activeName{
                max-width: 1000px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 15px;
                padding-top: 20px;
                span{
                    font-size: 42px;
                    color: #fff;
                    text-align: center;
                    width: 900px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                }
                img{
                    width: 100px;
                    height: 100px;
                }
            }
            .wall_box{
                width: 1000px;
                height: auto;
                background: rgba(255, 255, 255, 0.3);
                border-radius: 10px;
                .noSign{
                    font-size: 80px;
                    color: #fff;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
                .wall_main{
                    display: flex;
                    flex-wrap: wrap;
                    padding: 10px 64px 40px;
                    /*max-height: 790px;*/
                    /*overflow: hidden;*/
                    .wall_list{
                        /*display: flex;*/
                        /*flex-direction: column;*/
                        /*align-items: center;*/
                        /*margin-right: 30px;*/
                        /*margin-top: 30px;*/
                        opacity: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 30px;
                        margin-top: 30px;
                        /*position: absolute;*/
                        /*top: 0;*/
                        /*left: 0;*/
                        img{
                            width: 120px;
                            height: 120px;
                            border-radius: 50%;
                            background: #eee;
                            -webkit-animation: sec_poofing1 1.4s;
                            /*animation: sec_poofing1 1.4s;*/
                            /*animation-fill-mode : forwards*/
                        }
                        p{
                            font-size: 24px;
                            color: #FFFFFF;
                            line-height: 33px;
                            padding-top: 12px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            max-width: 120px;
                            -webkit-animation: sec_poofing1 1.4s;
                            animation: sec_poofing1 1.4s;
                            animation-fill-mode : forwards
                        }
                    }
                    .wall_list:nth-child(6n){
                        margin-right: 0;
                    }
                    .wall_list.set{
                        opacity: 1!important;
                        transform:perspective(800px) translate3d(0px,0px,0px) rotate(0deg) scale(1)!important;
                        -moz-transform:perspective(800px) translate3d(0px,0px,0px) rotate(0deg) scale(1)!important;
                        -webkit-transform:perspective(800px) translate3d(0px,0px,0px) rotate(0deg) scale(1)!important;
                    }
                }
                .el-carousel__indicators,.el-carousel__arrow{
                    display: none;
                }
                /*@keyframes sec_poofing1 {*/
                /*0% {*/
                /*-webkit-transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);*/
                /*transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);*/
                /*}*/
                /*50% {*/
                /*-webkit-transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);*/
                /*transform: rotateZ(0deg) rotateY(360deg) translateY(0px) scale(1);*/
                /*}*/
                /*56% {*/
                /*-webkit-transform: rotateZ(268deg) rotateY(360deg) translateY(0px) scale(1);*/
                /*transform: rotateZ(268deg) rotateY(360deg) translateY(0px) scale(1);*/
                /*}*/
                /*100% {*/
                /*-webkit-transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);*/
                /*transform: rotateZ(0deg) rotateY(0) translateY(0px) scale(1);*/
                /*}*/
                /*}*/
            }
        }
        /*position: relative;*/
    }
    .el-dialog{
        margin-top: 0!important;
        top: 50%;
        transform: translate(0,-50%);
        border-radius: 6px;
        .el-dialog__header{
            display: none;
        }
        .signPoup{
            .singleNum{
                img{
                    width: 120px;
                    height: 120px;
                    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
                    background: #eee;
                    border-radius: 50%;
                    margin: -80px auto 10px;
                }
            }
            .doubleNum{
                .head{
                    display: flex;
                    justify-content: center;
                    img{
                        width: 82px;
                        height: 82px;
                        min-width: 82px;
                        min-height: 82px;
                        background: #eee;
                        border-radius: 50%;
                        margin: -80px -10px 10px;
                        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
                    }
                }
                .nameBox{
                    display: flex;
                    justify-content: center;
                    .nameList{
                        max-width: 360px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            p{
                font-size: 28px;
                color: #000;
                line-height: 40px;
                text-align: center;
                width: 360px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .red{
                color: #EC5E69;
                margin-top: 10px;
            }
        }
    }
}
</style>